import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";
import { Grid } from "@mui/material";
import { propDateField, propSimpleEnumField, propNumberField } from "../../common/entityStoreForm";
import { propRequired, propValidValue, propMinValue } from "../../common/entityStoreValidators";
import { today, withSameProp } from "../../common/utils";
import { EnumItemDto } from "../../common/enum";

enum RunVariant {
    All = 1 | 2,
    Run = 1,
    Reports = 2,
}

const runVariants: EnumItemDto[] = [
    { id: RunVariant.All, name: "Complete run with reports" },
    { id: RunVariant.Run, name: "Run without reports" },
    { id: RunVariant.Reports, name: "Only payment/return reports" },
];

export const WriteOffRunPage = withSameProp("fake", () => (props: { fake?: boolean }) => {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: { runDate: today(), runVariant: RunVariant.All },
        id: null,
        propValidators: [
            propValidValue("runDate", "runDateFormatted"),
            propRequired("runDate"),
            propRequired("runVariant"),
            propMinValue("transferOnlyMinTotalPaidAmount", 0),
            propValidValue("transferOnlyMinTotalPaidAmount", "transferOnlyMinTotalPaidAmountFormatted"),
        ]
    }));
    function renderParams() {
        return <>
            <Grid item xs={12}>{propDateField(useParamsStore)("runDate", "runDateFormatted", "Run date")}</Grid>
            <Grid item xs={12}>{propSimpleEnumField(useParamsStore)("runVariant", "Run variant", runVariants)}</Grid>
            <Grid item xs={12}>{propNumberField(useParamsStore)("transferOnlyMinTotalPaidAmount", "transferOnlyMinTotalPaidAmountFormatted", "Write-off without transfer if customer paid more then", { isCurrency: true })}</Grid>
        </>;
    }
    return <>
        <Run name="Write-off run" fake={props.fake} hub="writeOffRun"
            useParamsStore={useParamsStore} renderParams={renderParams} />
    </>;
});

interface RunParams {
    runDate: string;
    runDateFormatted?: string;
    runVariant?: RunVariant;
    transferOnlyMinTotalPaidAmount?: number;
    transferOnlyMinTotalPaidAmountFormatted?: string;
}
